import {
  CANCEL_SEARCH,
  FEEBACK_MODAL,
  FEEDBACK_ERROR,
  RESET_COMPLETE_GRAPH,
  SEND_FEEDBACK,
  SETUP_SIGNALR_CONNECTION,
  SET_CONNECTION,
  SET_TOKEN,
  INDIVDUAL_FILTERS,
  SHOW_FLAG_MODAL,
  HIDE_FLAG_MODAL,
  SEND_FLAG,
  FLAG_ERROR,
  SHOW_EDGE_FLAG_MODAL,
  HIDE_EDGE_FLAG_MODAL,
  SEND_EDGE_FLAG,
  EDGE_FLAG_ERROR,
  TOGGLE_FAVORITE,
  SET_FAVORITES,
  SET_ERROR,
  CLEAR_ERROR,
  SET_SEARCH_MODE,
  SET_FILTER_SESSION,
  CLEAR_FILTER_SESSION,
  EXECUTE_FILTER_SEARCH,
} from './constants';

export const setToken = (token, expires, username, refreshToken) => {
  return {
    type: SET_TOKEN,
    token,
    expires,
    username,
    refreshToken,
  };
};

export const setConnection = (connection) => {
  return {
    type: SET_CONNECTION,
    connection,
  };
};

export const setupConnection = (token) => {
  return {
    type: SETUP_SIGNALR_CONNECTION,
    token,
  };
};

export const sendFeedback = (request) => {
  return {
    type: SEND_FEEDBACK,
    payload: request,
  };
};

export const showFeedbackModal = (option, imageUrl) => {
  return {
    type: FEEBACK_MODAL,
    payload: true,
    option,
    imageUrl,
  };
};

// Show flag modal with node info
export const showFlagModal = (nodeId, nodeName, nodeType) => {
  return {
    type: SHOW_FLAG_MODAL,
    payload: { nodeId, nodeName, nodeType },
  };
};

// Hide flag modal
export const hideFlagModal = (success = false) => {
  return {
    type: HIDE_FLAG_MODAL,
    payload: success,
  };
};

// Send flag to backend
export const sendFlag = (nodeId, description, category) => {
  return {
    type: SEND_FLAG,
    payload: { nodeId, description, category },
  };
};

export const setFlagError = (error) => {
  return {
    type: FLAG_ERROR,
    payload: error,
  };
};

// Show edge flag modal with edge info
export const showEdgeFlagModal = (edgePayload) => {
  return {
    type: SHOW_EDGE_FLAG_MODAL,
    payload: edgePayload,
  };
};

// Hide edge flag modal
export const hideEdgeFlagModal = (success = false) => {
  return {
    type: HIDE_EDGE_FLAG_MODAL,
    payload: success,
  };
};

// Send edge flag to backend
export const sendEdgeFlag = (edgeId, description, category, edgeContext) => {
  return {
    type: SEND_EDGE_FLAG,
    payload: { edgeId, description, category, edgeContext },
  };
};

export const setEdgeFlagError = (error) => {
  return {
    type: EDGE_FLAG_ERROR,
    payload: error,
  };
};

// set success to first show success before hiding
export const hideFeedbackModal = (success = false) => {
  return {
    type: FEEBACK_MODAL,
    payload: success,
  };
};

export const setFeedBackError = (payload) => {
  return {
    type: FEEDBACK_ERROR,
    payload,
  };
};

export const resetCompleteGraph = () => {
  return {
    type: RESET_COMPLETE_GRAPH,
  };
};

export const cancelSearch = (payload = false) => {
  return {
    type: CANCEL_SEARCH,
    payload,
  };
};
export const setShowIndividualFilters = (payload = false) => {
  return {
    type: INDIVDUAL_FILTERS,
    payload,
  };
};

// Favorites
export const toggleFavorite = (node) => {
  return {
    type: TOGGLE_FAVORITE,
    payload: node,
  };
};

export const setFavorites = (favorites) => ({
  type: SET_FAVORITES,
  payload: favorites,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const setSearchMode = (mode) => ({
  type: SET_SEARCH_MODE,
  payload: mode,
});

export const setFilterSession = (session) => ({
  type: SET_FILTER_SESSION,
  payload: session,
});

export const clearFilterSession = () => ({
  type: CLEAR_FILTER_SESSION,
});

export const executeFilterSearch = (filters) => ({
  type: EXECUTE_FILTER_SEARCH,
  payload: filters,
});
